module.exports = __webpack_public_path__ + "static/media/home_production_cover.285eb3bf.jpg";